import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerMemberManagementDashboardType } from "../../looker-member-management-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-bill-detail-report",
  templateUrl: "./bill-detail-report.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillDetailReportComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerMemberManagementDashboardType.Bill_Detail_Report;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, HideFilters.CUSTOMER_NAME2];
}
